import React from 'react';
import RawEntryFields from './RawEntryFields';

/**
 * EntryData: Component to display the current data for a single entry.
 * Thin wrapper around RawEntryFields to standardize props and future-proof
 * rendering customizations for the Data Management page.
 *
 * Props:
 * - entry: object (required)
 * - unifiedRawKeys?: string[] — optional ordering/visibility for raw fields
 * - unifiedOutputKeys?: string[] — optional ordering/visibility for outputs
 * - fileDownloadContext?: { suffix, groupSlug } — forwarded to RawEntryFields for “View file”
 */
function EntryData({ entry, unifiedRawKeys, unifiedOutputKeys, fileDownloadContext, ...rest }) {
  return (
    <RawEntryFields
      entry={entry}
      visibleKeys={unifiedRawKeys}
      outputVisibleKeys={unifiedOutputKeys}
      fileDownloadContext={fileDownloadContext}
      {...rest}
    />
  );
}

export default EntryData;
